import User from "app/models/user"
import { Params } from "./planningAvailabilities.reducer"

export enum Types {
  GET = "PLANING_AVAILABILITIES_GET",
  GET_SUCCESS = "PLANING_AVAILABILITIES_GET_SUCCESS",
  GET_FAIL = "PLANING_AVAILABILITIES_GET_FAIL",
  RESET_PARAMS = "PLANING_AVAILABILITIES_RESET_PARAMS",
}

export type Action =
  | GetAvailabilitiesAction
  | GetAvailabilitiesSuccessAction
  | GetAvailabilitiesFailAction
  | ResetParams

export type GetAvailabilitiesAction = {
  payload: Params
  type: Types.GET
}

export type GetAvailabilitiesSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { data: User[] }
}

export type GetAvailabilitiesFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export type ResetParams = {
  type: Types.RESET_PARAMS
}

export function getAvailabilities(payload: Params): GetAvailabilitiesAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getAvailabilitiesSuccess(data: User[]): GetAvailabilitiesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getAvailabilitiesFail(errors: object): GetAvailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function resetParams(): ResetParams {
  return {
    type: Types.RESET_PARAMS,
  }
}
